import authRequest from "@/api/http/authRequest";

export default {
  popupInfos(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get('/admin/popup-info', params, cb, errCb)
  },
  patchPopupInfo(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/popup-info/${params.id}`, params, cb, errCb)
  },
  searchLessons(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/lessons`, params, cb, errCb)
  },
  lessons(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/lessons/list`, params, cb, errCb)
  },
  lessonDetail(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/lesson/${params.id}`, params, cb, errCb)
  },
  lessonContents(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/lessons_contents`, params, cb, errCb)
  },
}
